/**
 * Upselling & Packaging Logik im Shopify Cart
 */
document.addEventListener('DOMContentLoaded', () => {
    attachCartEventListeners();
    fetchAndHandleCart();
  });
  
  function attachCartEventListeners() {
    ['onItemDeleted', 'onQuantityChange'].forEach(eventName => {
      document.addEventListener(eventName, fetchAndHandleCart);
    });
  }
  
  function fetchAndHandleCart() {
    fetch('/cart.js', {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    })
      .then(res => res.json())
      .then(handleCartLoad)
      .catch(console.error);
  }
  
  function handleCartLoad(cart) {
    const settings = getUpsellingSettings();
    const packagingOptions = settings.packagingOptions || [];
    const packagingLimit = settings.general?.packaging_options_products_limit || Infinity;
    const upsellingLimit = settings.general?.upselling_limit || Infinity;
    const upsellingEnabled = settings.general?.upselling_enabled;
  
    const packagingSelector = document.querySelector("packaging-options-selector");
    const upsellingSection = document.querySelector('.upselling[data-section-upselling]');
    const checkoutButton = document.querySelector(".cart__checkout-button");
  
    const cartItemsCount = getValidCartItemCount(cart.items, packagingOptions);
  
    if (cart.items.length) checkoutButton?.removeAttribute("disabled");
  
    validateLineItemsRelatedCover(cart.items);
  
    // Upselling Sichtbarkeit
    if (upsellingEnabled) {
      upsellingSection?.classList.toggle('hidden', cartItemsCount > upsellingLimit);
    }
  
    // Geschenkoptionen Sichtbarkeit
    if (cartItemsCount && cartItemsCount <= packagingLimit) {
      packagingSelector?.removeAttribute("hidden");
    }
  
    const { singleCollection, multiCollection } = splitPackagingCollections(packagingOptions);
  
    const cartHasPackagingItem = cart.items.some(item =>
      packagingOptions.some(opt => item.id === opt.variantId)
    );
  
    const cartSinglePackagingItems = cart.items.filter(item =>
      singleCollection.some(opt => item.id === opt.variantId)
    );
  
    const cartMultiPackagingItems = cart.items.filter(item =>
      multiCollection.some(opt => item.id === opt.variantId)
    );
  
    if (cartHasPackagingItem) {
      if (cartItemsCount === 1 && cartSinglePackagingItems.length) {
        disableQuantityInputs(cartSinglePackagingItems);
      }
  
      const shouldRemovePackaging =
        (cartItemsCount === 1 && cartMultiPackagingItems.length) ||
        (cartItemsCount > 1 && cartSinglePackagingItems.length) ||
        cartItemsCount === 0 ||
        (upsellingEnabled && cartItemsCount > upsellingLimit);
  
      if (shouldRemovePackaging) {
        handleInvalidCart(packagingOptions.map(p => p.variantId));
      }
    }
  }
  
  function getValidCartItemCount(items, packagingOptions) {
    return items.filter(item =>
      item.properties._is_related_cover !== "true" &&
      !item.product_type.includes("PPLR_HIDDEN_PRODUCT") &&
      !packagingOptions.some(opt => item.id === opt.variantId)
    ).reduce((sum, item) => sum + item.quantity, 0);
  }
  
  function disableQuantityInputs(items) {
    items.forEach(item => {
      const input = document.querySelector(`.quantity__input[data-variant-id="${item.id}"]`);
      if (input) {
        input.disabled = true;
        ['plus', 'minus'].forEach(name => {
          const btn = input.parentElement.querySelector(`button[name="${name}"]`);
          if (btn) {
            btn.disabled = true;
            btn.classList.add("disabled");
          }
        });
      }
    });
  }
  
  function handleInvalidCart(variantIds) {
    const updates = {};
    variantIds.forEach(id => updates[id] = 0);
    updateCart({ updates });
  }
  
  function updateCart(data) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
      .then(res => res.json())
      .then(() => setTimeout(() => window.location.reload(), 300))
      .catch(console.error);
  }
  
  function addToCart(variantId, quantity, properties = null) {
    const payload = { id: variantId, quantity };
    if (properties) payload.properties = properties;
  
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(res => res.json())
      .then(() => setTimeout(() => window.location.reload(), 300))
      .catch(console.error);
  }
  
  function validateLineItemsRelatedCover(items) {
    items.forEach(item => {
      const relatedId = item.properties?._related_cover ? Number(item.properties?._related_cover) : null;
      if (relatedId) {
        // Check if a related item for this parent exists
        const hasRelated = items.some(i =>
          i.id === relatedId &&
          i.properties?._is_related_cover === "true" &&
          i.properties?._parent_key === item.key // unique cart key of parent
        );

        if (!hasRelated) {
          addToCart(relatedId, item.quantity, {
            _is_related_cover: "true",
            _parent_key: item.key
          });
        }
      }
    });
  }
  
  function splitPackagingCollections(options) {
    return {
      singleCollection: options.filter(o => o.collectionHandle === "geschenkoption-einzelversand"),
      multiCollection: options.filter(o => o.collectionHandle === "geschenkoption-massenversand")
    };
  }
  
  function getUpsellingSettings() {
    const el = document.querySelector('[data-upselling-settings]');
    try {
      return JSON.parse(el?.textContent || "{}");
    } catch {
      return {};
    }
  }
  